export class ColorHerlper {
    static calculateTextColorByBackground(bgColor: string) {
        const rgb = ColorHerlper.convertToRbg(bgColor);
        
        return ColorHerlper.colourIsLight(rgb) ? 'black' : 'white';
    }

    private static colourIsLight(rgb: Rgb){
        const a = 1 - ((0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b)  /255);
        
        return (a < 0.5);
    }

    private static convertToRbg(bgColor: string): Rgb {
        if (bgColor.startsWith('#')) {
            return ColorHerlper.hexToRgb(bgColor);
        }
        else if (bgColor.startsWith('rgb')) {
            return ColorHerlper.stringToRgb(bgColor);
        }

        throw 'Other types of color are not supported.'
    }

    private static stringToRgb(value: string): Rgb {
        const reg = /rgb[a]?\(([0-9.]*),([0-9.]*),([0-9.]*)/;

        const matches = value.match(reg);

        return {
            r: parseInt(matches[0]),
            g: parseInt(matches[1]),
            b: parseInt(matches[2]),
        };
    }

    private static hexToRgb(hex: string): Rgb {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
}

interface Rgb {
    r: number;
    g: number;
    b: number;
}